import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

// 三档软件版本，来自产品/定价体系.md
const PLAN_OPTIONS = [
  { value: 'free', label: '免费版', price: '¥0/年', color: '#999', desc: '免费送统一小程序·活动30次/月·孩子50人·10GB' },
  { value: 'standard', label: '标准版', price: '¥999/年', color: '#1890ff', desc: '统一品牌小程序·无限额·主力产品' },
  { value: 'custom', label: '独立定制版', price: '¥6,999/年', color: '#722ed1', desc: '机构自有小程序·全功能·需自行注册微信' },
]

const CW_OPTIONS = [
  { value: 'none', label: '未开通', desc: '无课件访问权限', color: '#999' },
  { value: 'basic', label: '基础版', desc: '1部·信守承诺（13课）', color: '#52c41a' },
  { value: 'standard', label: '标准版', desc: '1部+2部·珍惜（26课）', color: '#1890ff' },
  { value: 'premium', label: '高级版', desc: '全部 + 未来课程', color: '#722ed1' },
]

function getPlanLabel(plan) { return PLAN_OPTIONS.find(p => p.value === plan)?.label || '免费版' }
function getPlanColor(plan) { return PLAN_OPTIONS.find(p => p.value === plan)?.color || '#999' }
function getCwLabel(v) { return CW_OPTIONS.find(p => p.value === v)?.label || '未开通' }
function getCwColor(v) { return CW_OPTIONS.find(p => p.value === v)?.color || '#999' }
function formatDate(d) { return d ? new Date(d).toLocaleDateString('zh-CN') : '永久' }

export default function Organizations() {
  const [orgs, setOrgs] = useState([])
  const [loading, setLoading] = useState(true)
  const [showModal, setShowModal] = useState(false)
  const [modalTab, setModalTab] = useState('info')
  const [selectedOrg, setSelectedOrg] = useState(null)
  const [miniappCode, setMiniappCode] = useState(null)
  const [generatingCode, setGeneratingCode] = useState(false)
  const [miniappCfg, setMiniappCfg] = useState(null)
  const [miniappCfgLoading, setMiniappCfgLoading] = useState(false)
  const [miniappCfgSaving, setMiniappCfgSaving] = useState(false)
  const [miniappCfgMsg, setMiniappCfgMsg] = useState('')

  const [newBanners, setNewBanners] = useState([])
  const [newAnnouncement, setNewAnnouncement] = useState('')
  const [newBannerUrl, setNewBannerUrl] = useState('')
  const [newBannerLink, setNewBannerLink] = useState('')
  const [saving, setSaving] = useState(false)
  const [orgUsers, setOrgUsers] = useState([])
  const [newUserForm, setNewUserForm] = useState({ phone: '', name: '', username: '' })
  const [creatingUser, setCreatingUser] = useState(false)
  const [infoForm, setInfoForm] = useState({ name: '', type: '加盟', address: '', contact: '', phone: '', status: 'active' })
  const [planForm, setPlanForm] = useState({ plan: 'free', expireYears: 1 })
  const [cwForm, setCwForm] = useState({ courseware_enabled: false, courseware_version: 'none', expireYears: 1 })

  useEffect(() => { loadOrgs() }, [])

  // 切换到小程序预览 tab 时自动加载配置
  useEffect(() => {
    if (modalTab === 'miniapp' && selectedOrg && !miniappCfg && !miniappCfgLoading) {
      loadMiniappCfg(selectedOrg.id)
    }
  }, [modalTab, selectedOrg])

  const loadOrgs = () => {
    setLoading(true)
    fetch(`${API}/institutions`)
      .then(r => r.json())
      .then(d => { if (d.success) setOrgs(d.data || []) })
      .catch(e => { console.error(e) })
      .finally(() => setLoading(false))
  }

  const handleCreateOrg = async () => {
    if (!infoForm.name.trim()) {
      alert('请输入机构名称')
      return
    }
    setSaving(true)
    try {
      const res = await fetch(`${API}/institutions`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(infoForm)
      })
      const d = await res.json()
      if (d.success) {
        loadOrgs()
        setShowModal(false)
        alert('机构创建成功！')
      } else {
        alert('创建失败：' + (d.error || '网络错误'))
      }
    } catch (e) {
      alert('创建失败：网络错误')
    }
    setSaving(false)
  }

  const loadOrgUsers = (institutionId) => {
    fetch(`${API}/users/institution?institution_id=${institutionId}`)
      .then(r => r.json())
      .then(d => { if (d.success) setOrgUsers(d.data || []) })
      .catch(e => { console.error(e) })
  }

  const loadMiniappCfg = async (instId) => {
    if (!instId) return;
    setMiniappCfgLoading(true);
    try {
      const res = await fetch('/cms/cms/api/institutions/' + instId + '/miniapp-config');
      const json = await res.json();
      if (json.success) { setMiniappCfg(json.data); setNewBanners(json.data.banners || []); setNewAnnouncement(json.data.announcement || ''); }
    } catch(e) { console.error('加载小程序配置失败', e); }
    setMiniappCfgLoading(false);
  }
  const saveMiniappCfg = async (banners, announcement) => {
    if (!selectedOrg) return;
    setMiniappCfgSaving(true);
    setMiniappCfgMsg('');
    try {
      const _b = banners || [];
      const _a = announcement !== undefined ? announcement : '';
      const res = await fetch('/cms/api/institutions/' + selectedOrg.id + '/miniapp-config', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ banners: _b, announcement: _a })
      });
      const json = await res.json();
      if (json.success) {
        setMiniappCfg(json.data);
        setMiniappCfgMsg('✅ 保存成功');
        setTimeout(() => setMiniappCfgMsg(''), 3000);
      } else {
        setMiniappCfgMsg('❌ ' + (json.error || '保存失败'));
      }
    } catch(e) { setMiniappCfgMsg('❌ 网络错误'); }
    setMiniappCfgSaving(false);
  }
  const openOrg = (org) => {
    setSelectedOrg(org)
    setInfoForm({ name: org.name || '', type: org.type || '加盟', address: org.address || '', contact: org.contact || '', phone: org.phone || '', status: org.status || 'active' })
    setPlanForm({ plan: org.plan || 'free', expireYears: 1 })
    setCwForm({ courseware_enabled: !!org.courseware_enabled, courseware_version: org.courseware_version || 'none', expireYears: 1 })
    setNewUserForm({ phone: '', name: '', username: '' })
    setMiniappCode(null)
    setMiniappCfg(null)
    setMiniappCfgMsg('')
    loadOrgUsers(org.id)
    setModalTab('info')
    setShowModal(true)
  }

  const handleSaveInfo = async () => {
    setSaving(true)
    try {
      const res = await fetch(`${API}/institutions/${selectedOrg.id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(infoForm) })
      const d = await res.json()
      if (d.success) { loadOrgs(); setShowModal(false) } else { alert('保存失败：' + (d.error || '')) }
    } catch (e) { alert('保存失败') }
    setSaving(false)
  }

  const handleSavePlan = async () => {
    setSaving(true)
    try {
      const res = await fetch(`${API}/institutions/${selectedOrg.id}/plan`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ plan: planForm.plan, expire_days: planForm.expireYears * 365 }) })
      const d = await res.json()
      if (d.success) { loadOrgs(); setSelectedOrg({ ...selectedOrg, plan: d.data.plan, plan_expire_at: d.data.plan_expire_at }); alert('软件版本已更新') } else { alert('保存失败：' + (d.error || '')) }
    } catch (e) { alert('保存失败') }
    setSaving(false)
  }

  const handleSaveCw = async () => {
    setSaving(true)
    try {
      const res = await fetch(`${API}/institutions/${selectedOrg.id}/courseware`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ courseware_enabled: cwForm.courseware_enabled ? 1 : 0, courseware_version: cwForm.courseware_version, expire_days: cwForm.expireYears * 365 }) })
      const d = await res.json()
      if (d.success) { loadOrgs(); alert('课件权限已更新') } else { alert('保存失败：' + (d.error || '')) }
    } catch (e) { alert('保存失败') }
    setSaving(false)
  }

  const handleCreateUser = async () => {
    const { phone, name, username } = newUserForm
    if (!phone || !/^1\d{10}$/.test(phone)) { alert('请输入正确的11位手机号'); return }
    setCreatingUser(true)
    try {
      const res = await fetch(`${API}/users/institution`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ institution_id: selectedOrg.id, phone, name, username: username || undefined }) })
      const d = await res.json()
      if (d.success) { setNewUserForm({ phone: '', name: '', username: '' }); loadOrgUsers(selectedOrg.id); alert('账号创建成功！默认密码：school123') } else { alert('创建失败：' + (d.error || '网络错误，请重试')) }
    } catch (e) { alert('创建失败：网络错误，请重试') }
    setCreatingUser(false)
  }

  const handleDeleteUser = async (userId, username) => {
    if (!confirm('确定删除账号 ' + username + '？删除后该账号将无法登录。')) return
    try {
      const res = await fetch(`${API}/users/institution?id=${userId}`, { method: 'DELETE' })
      const d = await res.json()
      if (d.success) loadOrgUsers(selectedOrg.id)
      else alert('删除失败')
    } catch (e) { alert('删除失败') }
  }

  return (
    <div style={{ padding: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <div><h2 style={{ fontSize: 20, margin: 0 }}>🏫 机构管理</h2><p style={{ color: '#999', fontSize: 13, margin: '4px 0 0' }}>管理校区/机构，配置小程序软件版本和课件权限</p></div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button onClick={() => { window.location.assign('/cms/?page=institution-register'); }} style={{ padding: '10px 20px', background: '#1890ff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 13, color: '#fff' }}>📝 机构申请</button>
          <button onClick={loadOrgs} style={{ padding: '10px 20px', background: '#fff', border: '1px solid #d9d9d9', borderRadius: 6, cursor: 'pointer', fontSize: 13 }}>🔄 刷新</button>
          <button onClick={() => { setSelectedOrg(null); setInfoForm({ name: '', type: '加盟', address: '', contact: '', phone: '', status: 'active' }); setPlanForm({ plan: 'free', expireYears: 1 }); setCwForm({ courseware_enabled: false, courseware_version: 'none', expireYears: 1 }); setOrgUsers([]); setShowModal(true); setModalTab('plan') }} style={{ padding: '10px 20px', background: '#52c41a', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 13, color: '#fff' }}>+ 添加机构</button>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 24 }}>
        <div style={card}><div style={{ color: '#999', fontSize: 12 }}>机构总数</div><div style={{ fontSize: 28, color: '#1890ff', fontWeight: 600 }}>{orgs.length}</div></div>
        <div style={card}><div style={{ color: '#999', fontSize: 12 }}>标准版</div><div style={{ fontSize: 28, color: '#1890ff', fontWeight: 600 }}>{orgs.filter(o => o.plan === 'standard').length}</div></div>
        <div style={card}><div style={{ color: '#999', fontSize: 12 }}>课件已开通</div><div style={{ fontSize: 28, color: '#52c41a', fontWeight: 600 }}>{orgs.filter(o => o.courseware_enabled).length}</div></div>
        <div style={card}><div style={{ color: '#999', fontSize: 12 }}>学员总数</div><div style={{ fontSize: 28, color: '#fa8c16', fontWeight: 600 }}>{orgs.reduce((s, o) => s + (o.students || 0), 0)}</div></div>
      </div>

      {loading ? <div style={{ textAlign: 'center', padding: 60, color: '#666' }}>加载中...</div> :
      <div style={{ background: '#fff', borderRadius: 8, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead><tr style={{ background: '#fafafa' }}>
            <th style={th}>机构名称</th><th style={th}>类型</th><th style={th}>城市</th><th style={th}>学员</th><th style={th}>软件版本</th><th style={th}>到期时间</th><th style={th}>课件权限</th><th style={th}>操作</th>
          </tr></thead>
          <tbody>
            {orgs.map(o => (
              <tr key={o.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                <td style={td}><div style={{ fontWeight: 500 }}>{o.name}</div><div style={{ fontSize: 11, color: '#999' }}>{o.code}</div></td>
                <td style={td}><span style={{ padding: '2px 8px', borderRadius: 10, fontSize: 11, background: o.type === '直营' ? '#e6f4ff' : '#fff3e6', color: o.type === '直营' ? '#1890ff' : '#fa8c16' }}>{o.type || '加盟'}</span></td>
                <td style={{ ...td, color: '#666' }}>{o.address || '-'}</td>
                <td style={{ ...td, color: '#1890ff' }}>{o.students || 0}</td>
                <td style={td}><span style={{ padding: '2px 8px', borderRadius: 10, fontSize: 11, background: getPlanColor(o.plan) + '22', color: getPlanColor(o.plan), fontWeight: 500 }}>{getPlanLabel(o.plan)}</span></td>
                <td style={{ ...td, fontSize: 12, color: '#666' }}>{formatDate(o.plan_expire_at)}</td>
                <td style={td}>{o.courseware_enabled ? <span style={{ padding: '2px 8px', borderRadius: 10, fontSize: 11, background: getCwColor(o.courseware_version) + '22', color: getCwColor(o.courseware_version) }}>{getCwLabel(o.courseware_version)}</span> : <span style={{ padding: '2px 8px', borderRadius: 10, fontSize: 11, background: '#f5f5f5', color: '#999' }}>未开通</span>}</td>
                <td style={td}><button onClick={() => openOrg(o)} style={{ ...btn, background: '#1890ff', color: '#fff' }}>管理</button></td>
              </tr>
            ))}
            {orgs.length === 0 && <tr><td colSpan={8} style={{ textAlign: 'center', padding: 40, color: '#666' }}>暂无机构数据</td></tr>}
          </tbody>
        </table>
      </div>}

      {showModal && (
        <div style={modalOverlay} onClick={() => setShowModal(false)}>
          <div style={modalContent} onClick={e => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
              <div><h3 style={{ margin: 0 }}>{selectedOrg ? selectedOrg.name : '添加机构'}</h3>{selectedOrg && <span style={{ fontSize: 12, color: '#999' }}>{selectedOrg.code}</span>}</div>
              <button onClick={() => setShowModal(false)} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer' }}>×</button>
            </div>
            <div style={{ display: 'flex', borderBottom: '1px solid #f0f0f0', marginBottom: 20 }}>
              {[{ key: 'info', label: '📋 基础信息' }, { key: 'plan', label: '💰 软件版本' }, { key: 'courseware', label: '📚 课件权限' }, { key: 'users', label: '👤 机构账号' }, { key: 'miniapp', label: '📱 小程序预览' }].map(t => (
                <button key={t.key} onClick={() => setModalTab(t.key)} style={{ padding: '10px 20px', border: 'none', background: 'none', cursor: 'pointer', fontSize: 13, borderBottom: modalTab === t.key ? '2px solid #1890ff' : '2px solid transparent', color: modalTab === t.key ? '#1890ff' : '#666', fontWeight: modalTab === t.key ? 600 : 400 }}>{t.label}</button>
              ))}
            </div>

            {modalTab === 'info' && (
              <div style={{ display: 'grid', gap: 12 }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                  <div><label style={label}>机构名称 *</label><input value={infoForm.name} onChange={e => setInfoForm({ ...infoForm, name: e.target.value })} style={input} /></div>
                  <div><label style={label}>机构类型</label><select value={infoForm.type} onChange={e => setInfoForm({ ...infoForm, type: e.target.value })} style={input}><option value="直营">直营</option><option value="加盟">加盟</option></select></div>
                </div>
                <div><label style={label}>城市/地址</label><input value={infoForm.address} onChange={e => setInfoForm({ ...infoForm, address: e.target.value })} style={input} /></div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                  <div><label style={label}>联系人</label><input value={infoForm.contact} onChange={e => setInfoForm({ ...infoForm, contact: e.target.value })} style={input} /></div>
                  <div><label style={label}>联系电话</label><input value={infoForm.phone} onChange={e => setInfoForm({ ...infoForm, phone: e.target.value })} style={input} /></div>
                </div>
                <div><label style={label}>状态</label><select value={infoForm.status} onChange={e => setInfoForm({ ...infoForm, status: e.target.value })} style={input}><option value="active">运营中</option><option value="inactive">已停用</option></select></div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12, marginTop: 8 }}>
                  <button onClick={() => setShowModal(false)} style={{ ...btn, background: '#f5f5f5', color: '#666' }}>取消</button>
                  <button onClick={selectedOrg ? handleSaveInfo : handleCreateOrg} disabled={saving} style={{ ...btn, background: '#1890ff', color: '#fff' }}>{saving ? '保存中...' : (selectedOrg ? '保存信息' : '创建机构')}</button>
                </div>
              </div>
            )}

            {modalTab === 'plan' && (
              <div>
                <p style={{ fontSize: 13, color: '#999', marginBottom: 16 }}>选择该机构的小程序软件版本。免费版也有统一品牌小程序。。</p>
                <div style={{ display: 'grid', gap: 10 }}>
                  {PLAN_OPTIONS.map(opt => (
                    <div key={opt.value} onClick={() => setPlanForm({ ...planForm, plan: opt.value })} style={{ padding: '14px 16px', border: '2px solid ' + (planForm.plan === opt.value ? opt.color : '#f0f0f0'), borderRadius: 8, cursor: 'pointer', background: planForm.plan === opt.value ? opt.color + '08' : '#fff' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div><span style={{ fontWeight: 600, fontSize: 14, color: opt.color }}>{opt.label}</span><span style={{ marginLeft: 10, fontSize: 13, color: opt.price === '免费' ? '#1890ff' : '#fa8c16' }}>{opt.price}</span></div>
                        {planForm.plan === opt.value && <span style={{ color: opt.color, fontSize: 18 }}>✓</span>}
                      </div>
                      <div style={{ fontSize: 12, color: '#999', marginTop: 4 }}>{opt.desc}</div>
                    </div>
                  ))}
                </div>
                {planForm.plan !== 'free' && (
                  <div style={{ marginTop: 16 }}>
                    <label style={label}>授权时长</label>
                    <select value={planForm.expireYears} onChange={e => setPlanForm({ ...planForm, expireYears: Number(e.target.value) })} style={input}>
                      <option value={1}>1年</option><option value={2}>2年（8折）</option><option value={3}>3年（75折）</option>
                    </select>
                    <div style={{ fontSize: 12, color: '#999', marginTop: 4 }}>到期时间：{new Date(Date.now() + planForm.expireYears * 365 * 24 * 60 * 60 * 1000).toLocaleDateString('zh-CN')}</div>
                  </div>
                )}
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12, marginTop: 20 }}>
                  <button onClick={() => setShowModal(false)} style={{ ...btn, background: '#f5f5f5', color: '#666' }}>取消</button>
                  <button onClick={handleSavePlan} disabled={saving} style={{ ...btn, background: '#1890ff', color: '#fff' }}>{saving ? '保存中...' : '保存版本'}</button>
                </div>
              </div>
            )}

            {modalTab === 'courseware' && (
              <div>
                <p style={{ fontSize: 13, color: '#999', marginBottom: 16 }}>机构购买课件版本产品后，在此手动开通对应权限。</p>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px', background: '#f9f9f9', borderRadius: 8, marginBottom: 16 }}>
                  <span style={{ fontSize: 14, fontWeight: 500 }}>课件中心访问</span>
                  <div onClick={() => setCwForm({ ...cwForm, courseware_enabled: !cwForm.courseware_enabled })} style={{ width: 44, height: 24, borderRadius: 12, background: cwForm.courseware_enabled ? '#52c41a' : '#d9d9d9', cursor: 'pointer', position: 'relative', transition: 'background 0.2s' }}>
                    <div style={{ width: 20, height: 20, borderRadius: '50%', background: '#fff', position: 'absolute', top: 2, transition: 'left 0.2s', left: cwForm.courseware_enabled ? 22 : 2 }} />
                  </div>
                  <span style={{ fontSize: 12, color: cwForm.courseware_enabled ? '#52c41a' : '#999' }}>{cwForm.courseware_enabled ? '已开通' : '未开通'}</span>
                </div>
                {cwForm.courseware_enabled && (
                  <div style={{ display: 'grid', gap: 10, marginBottom: 16 }}>
                    {CW_OPTIONS.filter(o => o.value !== 'none').map(opt => (
                      <div key={opt.value} onClick={() => setCwForm({ ...cwForm, courseware_version: opt.value })} style={{ padding: '12px 16px', border: '2px solid ' + (cwForm.courseware_version === opt.value ? opt.color : '#f0f0f0'), borderRadius: 8, cursor: 'pointer', background: cwForm.courseware_version === opt.value ? opt.color + '08' : '#fff' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                          <div><span style={{ fontWeight: 600, color: opt.color }}>{opt.label}</span><span style={{ marginLeft: 10, fontSize: 12, color: '#999' }}>{opt.desc}</span></div>
                          {cwForm.courseware_version === opt.value && <span style={{ color: opt.color, fontSize: 18 }}>✓</span>}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12, marginTop: 20 }}>
                  <button onClick={() => setShowModal(false)} style={{ ...btn, background: '#f5f5f5', color: '#666' }}>取消</button>
                  <button onClick={handleSaveCw} disabled={saving} style={{ ...btn, background: '#1890ff', color: '#fff' }}>{saving ? '保存中...' : '保存课件权限'}</button>
                </div>
              </div>
            )}

            {modalTab === 'users' && (
              <div>
                <p style={{ fontSize: 13, color: '#999', marginBottom: 16 }}>为机构创建登录账号，系统将自动发送包含默认密码的短信通知。默认密码为 <strong>school123</strong>，请提醒机构老师首次登录后修改。</p>
                <div style={{ background: '#f9f9f9', borderRadius: 8, padding: 16, marginBottom: 20 }}>
                  <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 12, color: '#333' }}>+ 新建账号</div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr auto', gap: 8, alignItems: 'end' }}>
                    <div><label style={label}>手机号 *</label><input type="text" placeholder="接收短信的手机号" value={newUserForm.phone} onChange={e => setNewUserForm({ ...newUserForm, phone: e.target.value })} maxLength={11} style={{ ...input, width: '100%' }} /></div>
                    <div><label style={label}>姓名（可选）</label><input type="text" placeholder="老师姓名" value={newUserForm.name} onChange={e => setNewUserForm({ ...newUserForm, name: e.target.value })} style={{ ...input, width: '100%' }} /></div>
                    <div><label style={label}>用户名（可选）</label><input type="text" placeholder="留空则用手机号" value={newUserForm.username} onChange={e => setNewUserForm({ ...newUserForm, username: e.target.value })} style={{ ...input, width: '100%' }} /></div>
                    <button onClick={handleCreateUser} disabled={creatingUser} style={{ padding: '9px 16px', background: creatingUser ? '#f5f5f5' : '#52c41a', color: creatingUser ? '#999' : '#fff', border: 'none', borderRadius: 4, cursor: creatingUser ? 'not-allowed' : 'pointer', fontSize: 13, whiteSpace: 'nowrap' }}>{creatingUser ? '创建中...' : '创建并通知'}</button>
                  </div>
                </div>
                <div style={{ marginBottom: 8, fontSize: 13, color: '#666', fontWeight: 500 }}>已创建账号（{orgUsers.length} 个）</div>
                {orgUsers.length === 0 ? <div style={{ textAlign: 'center', padding: 32, color: '#999', background: '#fafafa', borderRadius: 8 }}>暂无账号</div> :
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead><tr style={{ background: '#fafafa' }}><th style={{ ...th, fontSize: 12 }}>用户名</th><th style={{ ...th, fontSize: 12 }}>姓名</th><th style={{ ...th, fontSize: 12 }}>手机</th><th style={{ ...th, fontSize: 12 }}>创建时间</th><th style={{ ...th, fontSize: 12, textAlign: 'right' }}>操作</th></tr></thead>
                    <tbody>{orgUsers.map(u => <tr key={u.id} style={{ borderBottom: '1px solid #f0f0f0' }}><td style={{ ...td, fontWeight: 500 }}>{u.username}</td><td style={td}>{u.name || '-'}</td><td style={td}>{u.phone || '-'}</td><td style={{ ...td, fontSize: 12, color: '#999' }}>{u.created_at ? new Date(u.created_at).toLocaleDateString('zh-CN') : '-'}</td><td style={{ ...td, textAlign: 'right' }}><button onClick={() => handleDeleteUser(u.id, u.username)} style={{ padding: '4px 10px', background: '#ff4d4f22', color: '#ff4d4f', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12 }}>删除</button></td></tr>)}</tbody>
                  </table>
                }
              </div>
            )}

            {modalTab === 'miniapp' && (() => {
                // 配置在打开 tab 时自动加载（见 useEffect）
                
                const addBanner = () => {
                  if (!newBannerUrl.trim()) return;
                  setNewBanners([...newBanners, { image: newBannerUrl.trim(), link: newBannerLink.trim() }]);
                  setNewBannerUrl('');
                  setNewBannerLink('');
                  setMiniappCfgMsg('');
                };
                const removeBanner = (idx) => {
                  setNewBanners(newBanners.filter((_, i) => i !== idx));
                  setMiniappCfgMsg('');
                };
                const moveBanner = (idx, dir) => {
                  const arr = [...newBanners];
                  const target = idx + dir;
                  if (target < 0 || target >= arr.length) return;
                  [arr[idx], arr[target]] = [arr[target], arr[idx]];
                  setNewBanners(arr);
                  setMiniappCfgMsg('');
                };
                
                return (
              <div>
                <p style={{ fontSize: 13, color: '#999', marginBottom: 16 }}>配置机构小程序首页展示内容（Banner轮播 + 公告），配置完后生成机构专属小程序码。</p>
                
                {/* ===== 小程序配置表单 ===== */}
                {miniappCfgLoading ? (
                  <div style={{ background: '#fff', borderRadius: 12, padding: 30, marginBottom: 16, textAlign: 'center', color: '#999' }}>加载中...</div>
                ) : (
                  <>
                  {/* Banner 管理 */}
                  <div style={{ background: '#fff', borderRadius: 12, padding: 20, marginBottom: 16, boxShadow: '0 1px 6px rgba(0,0,0,0.06)' }}>
                    <div style={{ fontWeight: 600, fontSize: 15, marginBottom: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span>🖼️ Banner 轮播管理</span>
                      <span style={{ fontSize: 12, color: '#999', fontWeight: 400 }}>{newBanners.length} 张</span>
                    </div>
                    
                    {/* 现有 Banner 列表 */}
                    {newBanners.length > 0 ? (
                      <div style={{ marginBottom: 12 }}>
                        {newBanners.map((b, i) => (
                          <div key={i} style={{
                            display: 'flex', gap: 10, alignItems: 'center', padding: '10px 0',
                            borderBottom: i < newBanners.length - 1 ? '1px solid #f0f0f0' : 'none'
                          }}>
                            <div style={{ fontSize: 12, color: '#ccc', width: 20, textAlign: 'center' }}>{i + 1}</div>
                            <img src={b.image} style={{ width: 80, height: 45, borderRadius: 4, objectFit: 'cover' }} onError={e => e.target.style.display='none'} />
                            <div style={{ flex: 1, fontSize: 12, color: '#666', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{b.image}</div>
                            {b.link && <div style={{ fontSize: 11, color: '#999', maxWidth: 100, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>🔗 {b.link}</div>}
                            <button onClick={() => moveBanner(i, -1)} disabled={i === 0} style={{
                              border: 'none', background: 'none', cursor: i === 0 ? 'default' : 'pointer', fontSize: 14, opacity: i === 0 ? 0.3 : 1
                            }}>⬆️</button>
                            <button onClick={() => moveBanner(i, 1)} disabled={i === newBanners.length - 1} style={{
                              border: 'none', background: 'none', cursor: i === newBanners.length - 1 ? 'default' : 'pointer', fontSize: 14, opacity: i === newBanners.length - 1 ? 0.3 : 1
                            }}>⬇️</button>
                            <button onClick={() => removeBanner(i)} style={{
                              border: 'none', background: 'none', color: '#ff4d4f', cursor: 'pointer', fontSize: 14
                            }}>🗑️</button>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div style={{ padding: '16px 0', color: '#ccc', fontSize: 13, textAlign: 'center' }}>暂未配置 Banner</div>
                    )}
                    
                    {/* 添加新 Banner */}
                    <div style={{ background: '#fafafa', borderRadius: 8, padding: 12 }}>
                      <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 8 }}>添加 Banner</div>
                      <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
                        <input value={newBannerUrl} onChange={e => setNewBannerUrl(e.target.value)}
                          placeholder="图片链接（CDN URL）"
                          style={{ flex: 1, padding: '8px 10px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 12 }} />
                        <label style={{ padding: '8px 16px', background: '#fa8c16', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 12, whiteSpace: 'nowrap', display: 'inline-flex', alignItems: 'center' }}>
                          📁 上传
                          <input type="file" accept="image/*" onChange={async (e) => {
                            const file = e.target.files[0];
                            if (!file) return;
                            const formData = new FormData();
                            formData.append('file', file);
                            try {
                              const resp = await fetch('/cms/api/upload', { method: 'POST', body: formData });
                              const json = await resp.json();
                              if (json.success && json.url) {
                                setNewBannerUrl(json.url);
                              }
                            } catch(err) { console.error('Upload error:', err); }
                          }} style={{ display: 'none' }} />
                        </label>
                        <input value={newBannerLink} onChange={e => setNewBannerLink(e.target.value)}
                          placeholder="跳转链接（可选）"
                          style={{ flex: 1, padding: '8px 10px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 12 }} />
                        <button type="button" onClick={addBanner}
                          style={{ padding: '8px 16px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 12, whiteSpace: 'nowrap' }}>
                          + 添加
                        </button>
                      </div>
                      <div style={{ fontSize: 11, color: '#999' }}>建议尺寸 750×350。可粘贴 CDN 链接或点击「📁 上传」按钮直接上传。</div>
                    </div>
                  </div>
                  
                  {/* 公告编辑 */}
                  <div style={{ background: '#fff', borderRadius: 12, padding: 20, marginBottom: 16, boxShadow: '0 1px 6px rgba(0,0,0,0.06)' }}>
                    <div style={{ fontWeight: 600, fontSize: 15, marginBottom: 8 }}>📢 机构公告</div>
                    <textarea value={newAnnouncement} onChange={e => setNewAnnouncement(e.target.value)}
                      placeholder="在小程序机构首页顶部显示的公告内容（如：欢迎新生报名、寒假班开课通知等）"
                      rows={3}
                      style={{ width: '100%', padding: '10px 12px', border: '1px solid #d9d9d9', borderRadius: 8, fontSize: 13, resize: 'vertical' }} />
                    <div style={{ fontSize: 11, color: '#999', marginTop: 4 }}>留空则不显示公告栏</div>
                  </div>
                  
                  {/* 保存按钮 */}
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
                    <button type="button" onClick={() => saveMiniappCfg(newBanners, newAnnouncement)}
                      disabled={miniappCfgSaving}
                      style={{
                        padding: '10px 24px', background: miniappCfgSaving ? '#ccc' : '#52c41a', color: '#fff',
                        border: 'none', borderRadius: 8, cursor: miniappCfgSaving ? 'not-allowed' : 'pointer',
                        fontSize: 14, fontWeight: 600
                      }}>
                      {miniappCfgSaving ? '⏳ 保存中...' : '💾 保存配置'}
                    </button>
                    {miniappCfgMsg && <span style={{ fontSize: 13, color: miniappCfgMsg.startsWith('✅') ? '#52c41a' : '#ff4d4f' }}>{miniappCfgMsg}</span>}
                  </div>
                  </>
                )}
                
                {/* 分割线 */}
                <div style={{ borderTop: '1px solid #e8e8e8', margin: '16px 0' }}></div>
                
                {/* ===== 小程序码生成 ===== */}
                <p style={{ fontSize: 13, color: '#999', marginBottom: 16 }}>配置保存成功后，点击下方按钮生成机构专属小程序码。</p>
                
                {/* 生成按钮 */}
                <button
                  onClick={async () => {
                    setGeneratingCode(true);
                    try {
                      const API = '/api';
                      const res = await fetch(API + '/institutions/' + selectedOrg.id + '/wxacode', { method: 'POST', headers: { 'Content-Type': 'application/json' } });
                      const json = await res.json();
                      if (json.success) {
                        setMiniappCode(json.data);
                      } else {
                        alert('生成失败：' + (json.error || '未知错误'));
                      }
                    } catch(e) {
                      alert('请求失败：' + e.message);
                    }
                    setGeneratingCode(false);
                  }}
                  disabled={generatingCode || !selectedOrg}
                  style={{
                    padding: '12px 28px', background: generatingCode ? '#ccc' : '#1890ff', color: '#fff',
                    border: 'none', borderRadius: 8, cursor: generatingCode || !selectedOrg ? 'not-allowed' : 'pointer',
                    fontSize: 15, fontWeight: 600, marginBottom: 20, width: '100%'
                  }}
                >
                  {generatingCode ? '⏳ 生成中...' : '🔧 生成机构专属小程序码'}
                </button>

                {/* 小程序码展示 */}
                <div style={{ textAlign: 'center', padding: '20px 0' }}>
                  <div style={{ display: 'inline-block', background: '#fff', borderRadius: 12, padding: 16, boxShadow: '0 2px 12px rgba(0,0,0,0.08)', marginBottom: 16 }}>
                    <div style={{ fontSize: 12, color: '#999', marginBottom: 8 }}>
                      {miniappCode ? '机构专属小程序码' : '博小兔职业小镇 · 通用小程序码'}
                    </div>
                    {miniappCode ? (
                      <img src={miniappCode.image} alt="机构小程序码" style={{ width: 180, height: 180, display: 'block', margin: '0 auto' }} />
                    ) : (
                      <>
                        <img src="https://www.boxiaotu.cn/qrcode.jpg" alt="小程序码"
                          style={{ width: 180, height: 180, display: 'block', margin: '0 auto' }}
                          onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'block'; }} />
                        <div style={{ display: 'none', padding: '60px 0', color: '#999', fontSize: 13 }}>小程序码尚未生成，点击上方按钮生成</div>
                      </>
                    )}
                  </div>
                  <div style={{ fontSize: 13, color: '#666', lineHeight: 1.8 }}>
                    <div>📱 微信扫一扫或搜索<strong style={{ color: '#1890ff' }}>「博小兔职业小镇」</strong></div>
                    {miniappCode && <div style={{ fontSize: 11, color: '#52c41a', marginTop: 4 }}>✅ 机构专属码已生成 · 路径：{miniappCode.path}</div>}
                    <div style={{ fontSize: 12, color: '#999', marginTop: 4 }}>
                      当前机构：<strong>{selectedOrg?.name || '—'}</strong>
                      {selectedOrg?.code && <span>（{selectedOrg.code}）</span>}
                    </div>
                  </div>
                </div>

                <div style={{ background: '#f0f5ff', borderRadius: 8, padding: '12px 16px', marginTop: 16, fontSize: 12, color: '#666', lineHeight: 1.8 }}>
                  <div style={{ fontWeight: 600, color: '#1890ff', marginBottom: 4 }}>📋 小程序开通流程</div>
                  <div>1️⃣ 机构入驻并通过审核 → 开通软件版本（免费/标准/定制）</div>
                  <div>2️⃣ 机构在合作伙伴工作台配置品牌信息+商品上架</div>
                  <div>3️⃣ 点击上方按钮生成机构专属小程序码 → 下载使用</div>
                  <div>4️⃣ 家长扫码即进入机构品牌首页，看到该机构的活动和课程</div>
                </div>
              </div>
              )
              }
            )}
          </div>
        </div>
      )}
    </div>
  )
}

const card = { background: '#fff', borderRadius: 8, padding: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }
const th = { padding: 12, textAlign: 'left', fontSize: 13, color: '#666', fontWeight: 500 }
const td = { padding: 12, fontSize: 13 }
const btn = { padding: '8px 16px', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 13 }
const label = { display: 'block', marginBottom: 6, fontSize: 13, color: '#666' }
const input = { width: '100%', padding: '9px 12px', border: '1px solid #d9d9d9', borderRadius: 4, fontSize: 13, boxSizing: 'border-box' }
const modalOverlay = { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }
const modalContent = { background: '#fff', borderRadius: 8, padding: 24, width: 720, maxHeight: '85vh', overflowY: 'auto' }
